import {mutations} from "@/modules/DynamicProfiling/store/mutations";
import {actions} from "@/modules/DynamicProfiling/store/actions";
import {getters} from "@/modules/DynamicProfiling/store/getters";

const state = {
    dpVariables: null,
    projectCount: 0,
    projectMaxUsage: 0,
    panelistCount: 0,
    dynamicProfilingStats: null,
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

